import { render } from "./FeatureTabs.vue?vue&type=template&id=61a39b12"
import script from "./FeatureTabs.vue?vue&type=script&lang=js"
export * from "./FeatureTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__